module.exports = __webpack_public_path__ + "img/skill_develop.d30d8adf.svg";